<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4>{{ $t('schedules.edit') }}</h4>
      <CButton color="secondary" @click="goBack">{{ $t('goBack') }}</CButton>
    </div>
    
    <ExperienceAvailabilitiesForm 
      :baseSchedule="schedule" 
      :baseScheduleName="scheduleName"
      @submit-requested="onSubmitRequested" 
      :loading="loading">
    </ExperienceAvailabilitiesForm>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ExperienceAvailabilitiesForm from './ExperienceAvailabilitiesForm.vue';
import router from '@/router';

export default {
  components: { ExperienceAvailabilitiesForm },
  data() {
    return {
      loading: false,
      schedule: null,
      scheduleName: null
    };
  },
  computed: {
    ...mapState('experienceAvailabilities', ['getExperienceAvailabilityByIdOutput']),
    ...mapState('experienceAvailabilities', ['updateExperienceAvailabilityOutput'])
  },
  async mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.loading = true;
      try {
        await this.getById(id);
      } catch (error) {
        console.error('Error loading schedule:', error);
        this.$router.push({ name: 'ExperienceAvailabilitiesList' });
      } finally {
        this.loading = false;
      }
    } else {
      this.$router.push({ name: 'ExperienceAvailabilitiesList' });
    }
  },
  methods: {
    ...mapActions('experienceAvailabilities', ['getById']),
    ...mapActions('experienceAvailabilities', ['update']),
    async onSubmitRequested(schedule) {
      this.loading = true;
      try {
        await this.update(schedule);
      } catch (error) {
        console.error('Error updating schedule:', error);
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      router.push({ name: 'ExperienceAvailabilitiesList' });
    }
  },
  watch: {
    getExperienceAvailabilityByIdOutput(val) {
      if (val) {
        this.schedule = val;
        this.scheduleName = val.experience?.name || 'Schedule';
      }
    },
    updateExperienceAvailabilityOutput(val) {
      if (val) {
        this.loading = false;
      }
    }
  }
};
</script>

